<template>
    <div class="container-fluid mt-5">
        <div>
        <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
        >
            <template slot="header">
                <div class="row">
                    <div class="col-7 d-flex">
                        <h3 class="mb-0 mr-3">Reporte de Boletos</h3>
                        <base-button class="hover-apolo inline-block" type="default" icon size="sm" @click="reload()">
                        <span class="btn-inner--icon"
                            ><i class="fas fa-redo"></i
                        ></span>
                        </base-button>
                    </div>
                    <div class="col-5 text-right">
                        <base-button class="hover-apolo" type="default" icon size="sm" @click="downloadReport()">
                        <span class="btn-inner--icon"
                            ><i class="fas fa-download"></i
                        ></span>
                        <span class="btn-inner--text">Descargar Reporte</span>
                        </base-button>
                    </div>
                </div>
            </template>
            <div>
            <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mb-3"
            >   
                <span class="col-2">Fecha inicio:</span>
                <date-picker
                  class="col-3"
                  placeholder="Fecha inicio"
                  v-model="fecha_inicio"
                  :format="'DD-MM-YYYY'"
                  :lang="'es'"
                ></date-picker>
                <span class="col-2">Fecha fin:</span>
                <date-picker
                  class="col-3"
                  placeholder="Fecha fin"
                  v-model="fecha_fin"
                  :format="'DD-MM-YYYY'"
                  :lang="'es'"
                ></date-picker>
                <multiselect class="col-3 mt-2" v-model="status" :options="states" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar estatus" track-by="value" label="nombre" :showLabels="false"></multiselect>
                <multiselect v-if="agencias" class="col-3 mt-2" v-model="agencia_seleccionada" :options="agencias" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar agencia" track-by="id" label="nombre" :showLabels="false"></multiselect>
                <multiselect :disabled="isDisabledUsuarioAgencia" class="col-3 mt-2" v-model="usuario_seleccionado" :options="usuarios" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar usuario" track-by="id" label="name" :showLabels="false"></multiselect>
            </div>
            <div v-if="resumen_reportes" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mb-3">
                <div class="col-12" style="font-size: 20px;"><span>Totales:</span></div>
                <div class="col-12">
                    <span style="color: #0068a0;">Efectivo MXN: </span><span>${{ resumen_reportes[0].saldo_efectivo_mxn }}&nbsp;&nbsp;&nbsp;</span>
                    <span style="color: #0068a0;">Efectivo USD/MXN: </span><span>${{ resumen_reportes[0].efectivo_usd_mxn }}&nbsp;&nbsp;&nbsp;</span>
                    <span style="color: #0068a0;">Tarjeta: </span><span>${{ resumen_reportes[0].tarjeta }}&nbsp;&nbsp;&nbsp;</span>
                    <!--
                    <span style="color: #0068a0;">Depósito: </span><span>${{ resumen_reportes[0].deposito }}&nbsp;&nbsp;&nbsp;</span>
                    -->
                    <span style="color: #0068a0;">En línea: </span><span>${{ resumen_reportes[0].enlinea }}&nbsp;&nbsp;&nbsp;</span>
                    <span style="color: #0068a0;">Total: </span><span>${{ resumen_reportes[0].monto }}</span>
                </div>
            </div>
            <div style="overflow-x: scroll; width: auto;"> 
                <el-table
                    class="table-responsive align-items-center table-flush"
                    header-row-class-name="thead-light"
                    :data="reportes"
                    @sort-change="sortChange"
                >
                    <div slot="empty" v-if="loading">
                    <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                    </div>
    
                    <div slot="empty" v-if="reportes">
                    Sin datos disponibles
                    </div>
    
                    <el-table-column label="#" prop="attributes.id" min-width="100px" sortable/>
                    <el-table-column label="Terminal Origen" prop="attributes.terminal_origen" min-width="190px" sortable/>
                    <el-table-column label="Terminal Destino" prop="attributes.terminal_destino" min-width="200px" sortable/>
                    <el-table-column label="Asiento" min-width="130px" prop="attributes.asiento" sortable>
                        <div slot-scope="{ row }">
                        <span v-if="row.attributes.asiento">{{ row.attributes.asiento }}</span>
                        <span v-else> </span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Fecha y hora venta" min-width="220px" prop="attributes.fecha_venta" sortable>
                        <div slot-scope="{ row }">
                        <span v-if="row.attributes.fecha_venta">{{row.attributes.fecha_venta | moment('DD-MM-YYYY hh:mm')}}</span>
                        <span v-else> </span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Forma Pago" prop="attributes.metodo" min-width="160px" sortable/>
                    <el-table-column label="Valor" min-width="115px" prop="attributes.precio_lista" sortable>
                        <div slot-scope="{ row }">
                        <span v-if="row.attributes.precio_lista">${{ row.attributes.precio_lista }}</span>
                        <span v-else> </span>
                        </div> 
                    </el-table-column>
                    <el-table-column label="Status" prop="attributes.status_boleto" min-width="120px" sortable/>
                    <el-table-column label="Tipo" prop="attributes.categoria_asiento" min-width="110px" sortable/>
                    <el-table-column label="Cajero" prop="attributes.taquillero" min-width="160px" sortable/>
                    <el-table-column label="Agencia" min-width="180px" prop="attributes.agencia" sortable>
                        <div slot-scope="{ row }">
                        <span v-if="row.attributes.agencia">{{ row.attributes.agencia }}</span>
                        <span v-else> </span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Nombre Pasajero" prop="attributes.nombre_pasajero" min-width="200px" sortable/>
                    <el-table-column label="IP" prop="attributes.ip" min-width="150px" sortable/>
                    <el-table-column align="center" min-width="180px">
                        <div slot-scope="{ row }" class="table-actions">
                            <base-button class="hover-apolo" type="primary" icon size="sm" @click="getHistorial(row.attributes)">
                                <span class="btn-inner--text">Ver Historial</span>
                            </base-button>
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            </div>
            <div
            slot="footer"
            class="col-12"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
                >
                <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item.value"
                    :label="item.descripcion"
                    :value="Number(item.value)"
                >
                </el-option>
            </el-select>
            <div class="justify-content-center d-flex flex-wrap">
                <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
            />
            </div>
            
            </div>
        </card>
        </div>
        <!-- MODAL VER HISTORIAL -->
        <modal :show.sync="showHistorial" modal-classes="modal-primary" size="xl">
            <h6 slot="header" class="mb-0 modal-title">Ver Historial</h6>
            <form v-if="historial_info != null" class="new-event--form" @submit.prevent="">
                <div class="row">
                    <div class="col-12" style="font-size: 16px;"><span>Totales:</span></div>
                    <div v-if="historial_info" class="col-12">
                        <span style="color: #0068a0;">Precio: </span><span>${{ historial_info.precio_lista }}, </span>
                        <span style="color: #0068a0;">Descuento: </span><span>${{ historial_info.monto_descuento }}, </span>
                        <span style="color: #0068a0;">Canje: </span><span>${{ historial_info.monto_canje }}, </span>
                        <span style="color: #0068a0;">Total a pagar: </span><span>${{ historial_info.monto_total_pagar }}</span>
                    </div>
                    <div class="col-12" style="font-size: 16px;"><span>Fecha y hora de salida boleto: {{historial_info.fecha_salida | moment('DD-MM-YYYY hh:mm')}} hrs</span></div>
                </div>
                <div class="row">
                    <div class="col-12 mt-3" style="font-size: 16px;"><span>Ingresos</span></div>
                </div>
                <div style="overflow-x: scroll; width: auto;">
                <el-table
                    class="table-responsive align-items-center table-flush mt-3"
                    header-row-class-name="thead-light"
                    :data="historial_info.ingresos"
                    >
                    <div slot="empty" v-if="loading">
                        <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                    </div>
        
                    <div slot="empty" v-if="historial_info">
                        Sin datos disponibles
                    </div>
                    
                    <el-table-column label="Motivo" prop="motivo" min-width="175px"/>
                    <el-table-column label="Monto" prop="monto" min-width="110px">
                        <div slot-scope="{ row }">
                            <span>${{row.monto}}</span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Efectivo MXN" prop="efectivo_mxn" min-width="130px">
                        <div slot-scope="{ row }">
                            <span>${{row.efectivo_mxn}}</span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Efectivo USD" prop="efectivo_usd" min-width="125px">
                        <div slot-scope="{ row }">
                            <span>${{row.efectivo_usd}}</span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Tasa" prop="tasa_usd_mxn">
                        <div slot-scope="{ row }">
                            <span>${{row.tasa_usd_mxn}}</span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Efectivo USD/MXN" prop="efectivo_usd_mxn" min-width="165px">
                        <div slot-scope="{ row }">
                            <span>${{row.efectivo_usd_mxn}}</span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Tarjeta" prop="tarjeta" min-width="115px">
                        <div slot-scope="{ row }">
                            <span>${{row.tarjeta}}</span>
                        </div>
                    </el-table-column>
                    <!--
                    <el-table-column label="Depósito" prop="deposito" min-width="115px">
                        <div slot-scope="{ row }">
                            <span>${{row.deposito}}</span>
                        </div>
                    </el-table-column>
                    -->
                    <el-table-column label="En línea" prop="enlinea" min-width="115px">
                        <div slot-scope="{ row }">
                            <span>${{row.enlinea}}</span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Método" prop="metodo" min-width="115px"/>
                    <el-table-column label="Cambio" prop="cambio" min-width="115px">
                        <div slot-scope="{ row }">
                            <span>${{row.cambio}}</span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Saldo Efectivo" prop="saldo_efectivo_mxn" min-width="145px">
                        <div slot-scope="{ row }">
                            <span>${{row.saldo_efectivo_mxn}}</span>
                        </div>
                    </el-table-column>
                </el-table>
                </div>
                <div class="row">
                    <div class="col-12 mt-3" style="font-size: 16px;"><span>Egresos</span></div>
                </div>
                <el-table
                    class="table-responsive align-items-center table-flush mt-3"
                    header-row-class-name="thead-light"
                    :data="historial_info.egresos"
                    >
                    <div slot="empty" v-if="loading">
                        <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                    </div>
        
                    <div slot="empty" v-if="historial_info">
                        Sin datos disponibles
                    </div>
                    
                    <el-table-column label="Motivo" prop="motivo" />
                    <el-table-column label="Monto" prop="monto" />
                </el-table>

                <div class="row">
                    <div class="col-12 mt-3" style="font-size: 16px;"><span>Eventos</span></div>
                </div>
                <el-table
                    class="table-responsive align-items-center table-flush mt-3"
                    header-row-class-name="thead-light"
                    :data="historial_info.historial_eventos"
                    >
                    <div slot="empty" v-if="loading">
                        <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                    </div>
        
                    <div slot="empty" v-if="historial_info">
                        Sin datos disponibles
                    </div>
                    
                    <el-table-column label="Fecha" prop="fecha_evento">
                        <div slot-scope="{ row }">
                        <span v-if="row.fecha_evento">{{row.fecha_evento | moment('DD-MM-YYYY hh:mm')}}</span>
                        <span v-else> </span>
                        </div>
                    </el-table-column>
                    <el-table-column label="Descripción" prop="descripcion" />
                    <el-table-column label="Cajero" prop="creado_por.username" />
                    <el-table-column label="IP" prop="ip" />
                </el-table>
                <input type="hidden" class="new-event--start"/>
                <input type="hidden" class="new-event--end"/>
            </form>
    
            <template slot="footer">
                <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="close()">Cerrar</button>
            </template>
        </modal>
    </div>
    </template>
    <script>
    import Multiselect from 'vue-multiselect';
    import formMixin from "@/mixins/form-mixin";
    import ValidationError from "@/components/ValidationError.vue";
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import { BasePagination, Modal, BaseSwitch } from "@/components/";
    import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
    } from "element-ui";
    import swal from "sweetalert2";
    import "sweetalert2/dist/sweetalert2.css";
    import { throws } from 'assert';
    
    export default {
    layout: "DashboardLayout",
    
    components: {
        ValidationError,
        Modal,
        Multiselect,
        DatePicker,
        BaseSwitch,
        BasePagination,
        [Tooltip.name]: Tooltip,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
    },
    
    mixins: [formMixin],
    
    data() {
        return {
            reportes: [],
            resumen_reportes: null,
            status: null,
            agencia_seleccionada: null,
            usuario_seleccionado: null,
            fecha_inicio: null,
            fecha_fin: null,
            states: [
                { nombre: 'Todos los Estatus', value: 'Todos los Estatus'},
                { nombre: 'Vendido', value: 'Vendido'},
                { nombre: 'Anulado', value: 'Anulado'},
                { nombre: 'Blanco', value: 'Blanco'},
                { nombre: 'Reserva', value: 'Reserva'}
            ],
    
            sort: "-fecha_venta",
    
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [{value:'5', descripcion: '5 boletos por página'},
                {value:'10', descripcion: '10 boletos por página'},
                {value:'25', descripcion: '25 boletos por página'},
                {value:'50', descripcion: '50 boletos por página'}],
            },
            total: 0,
            loading: true,
            reporte: {
                type: "reporte",
                fecha_inicio: null,
                fecha_fin: null,
                agencia_id: null,
                usuario_id: null
            },
            agencias: [],
            usuarios: [],
            showHistorial: false,
            historial_info: null,
            params: null
        };
    },
    
    computed: {
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
    
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        isDisabledUsuarioAgencia(){
            if(this.agencia_seleccionada != null){
                return false;
            }else{
                return true;
            }
        },
    },
    
    watch: {
        status: {
            handler: "getListDebounced",
            immediate: false,
        },
        fecha_inicio: {
            handler: "getListDebounced",
            immediate: false,
        },
        fecha_fin: {
            handler: "getListDebounced",
            immediate: false,
        },
        agencia_seleccionada: {
            handler: "getUsuarios",
            immediate: false,
        },
        usuario_seleccionado: {
            handler: "getListDebounced",
            immediate: false,
        },
        usuarios: {
            handler: "getListDebounced",
            immediate: false,
        },
        pagination: {
            handler: "getList",
            immediate: false,
            deep: true,
        },
    },
    
    created(){
        //this.getAgencias();
    },
    
    async mounted(){
        await this.getAgencias();
        this.status = this.states.find(option => option.value === 'Todos los Estatus');
        this.fecha_fin = new Date(),
        this.fecha_inicio = new Date((this.fecha_fin.getMonth()+1)+' '+'1'+' '+this.fecha_fin.getFullYear());
    },
    
    methods: {
        reload(){
            this.$router.go(this.$router.currentRoute)
        },
        getListDebounced: _.debounce(function () {
            this.getList();
        }, 300),
    
        async getList() {
            var fecha_inicio_format = null;
            var fecha_fin_format = null;
            if(this.fecha_inicio != null){
                var fecha_inicio = this.fecha_inicio;
                fecha_inicio_format = fecha_inicio.getFullYear()  + "-" + ("0"+(fecha_inicio.getMonth()+1)).slice(-2) + "-" + ("0" + fecha_inicio.getDate()).slice(-2);
            }
            if(this.fecha_fin != null){
                var fecha_fin = this.fecha_fin;
                var fecha_hora = new Date(new Date().setHours(23,59,59,0));
                fecha_fin_format = fecha_fin.getFullYear()  + "-" + ("0"+(fecha_fin.getMonth()+1)).slice(-2) + "-" + ("0" + fecha_fin.getDate()).slice(-2);
            }
            if(fecha_inicio_format != null && fecha_fin_format != null){
                if(fecha_inicio_format > fecha_fin_format){
                    this.$notify({
                        type: "danger",
                        message: "La fecha fin debe ser mayor que la fecha inicio",
                        duration: -1
                    });
                    return;
                }
            }

            let params = {
                ...(this.sort ? { sort: this.sort } : {}),
                filter: {
                //...(this.search ? { search: this.search } : {}),
                ...(this.status ? { status: this.status.value } : {}),
                ...(this.agencia_seleccionada ? { agencia_id: this.agencia_seleccionada.id } : {}),
                ...(this.usuario_seleccionado ? { user_id: this.usuario_seleccionado.id } : {}),
                ...({ fecha_inicio: fecha_inicio_format }),
                ...( { fecha_fin: fecha_fin_format }),
                },
                page: {
                    number: this.pagination.currentPage,
                    size: this.pagination.perPage,
                },
            };
            this.params = {
                ...(this.sort ? { sort: this.sort } : {}),
                filter: {
                //...(this.search ? { search: this.search } : {}),
                ...(this.status ? { status: this.status.value } : {}),
                ...(this.agencia_seleccionada ? { agencia_id: this.agencia_seleccionada.id } : {}),
                ...(this.usuario_seleccionado ? { user_id: this.usuario_seleccionado.id } : {}),
                ...({ fecha_inicio: fecha_inicio_format }),
                ...( { fecha_fin: fecha_fin_format }),
                }
            };
            await this.$store.dispatch("reporte_boletos/list", params).then(() => {
                this.reportes = this.$store.getters["reporte_boletos/list"];
                this.total = this.$store.getters["reporte_boletos/listTotal"];
                this.resumen_reportes = this.$store.getters["reporte_boletos/resumen"];
            });
            this.loading = false;
        },

        async getAgencias() {
            await this.$store.dispatch("agencias/listActive").then(() => {
                this.agencias = this.$store.getters["agencias/listActive"];
            });
            this.agencias.unshift({"id": '-1', "nombre": 'Venta en Línea'});
            this.agencias.unshift({"id": '0', "nombre": 'Todas las Agencias'});
            let me = await this.$store.getters["profile/me"];
            if(me.attributes.agencia_activa != 'sin agencia'){
                this.agencia_seleccionada = this.agencias.find(item => item.nombre == me.attributes.agencia_activa);
            }
        },

        async getUsuarios() {
            if(this.agencia_seleccionada != null){
                await this.$store.dispatch("agencias/listUser", this.agencia_seleccionada.id).then(() => {
                    this.usuarios = this.$store.getters["agencias/listUser"];
                });
            }else{
                this.usuarios = null;
            }
        },
    
        close(){
            if(this.showHistorial == true){
                this.historial_info = null;
                this.showHistorial = false;
            }
        },

        async getHistorial($boleto){
            console.log()
            await this.$store.dispatch("reporte_boletos/getHistorial", $boleto.id).then(() => {
                this.historial_info = this.$store.getters["reporte_boletos/getHistorial"];
            });
            this.historial_info.fecha_salida = $boleto.fecha_salida
            this.showHistorial = true;
        },

        async downloadReport(){
            await this.$store.dispatch("reporte_boletos/getReporte", this.params).then(() => {
            });
        },
    
        sortChange({ prop, order }) {
            if (order === "descending") {
                this.sort = `-${prop.replace('attributes.', '')}`;
            } else {
                this.sort = `${prop.replace('attributes.', '')}`;
            }
            this.getList();
        },
    },
    };
    </script>
    <style>
    .linkFactura{
        color: blue;
        cursor: pointer;
    }
    .multiselect__select{
        right: 10px !important;
    }

    .el-table .sort-caret.ascending {
        border-bottom-color: #C0C4CC !important;
    }

    </style>